import { render, staticRenderFns } from "./ThemePath.vue?vue&type=template&id=82828c3c&scoped=true&"
import script from "./ThemePath.vue?vue&type=script&lang=ts&"
export * from "./ThemePath.vue?vue&type=script&lang=ts&"
import style0 from "./ThemePath.vue?vue&type=style&index=0&id=82828c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82828c3c",
  null
  
)

export default component.exports